module.exports = __webpack_public_path__ + "img/wechat.fa1c72a2.jpg";